import { useState } from 'react';
import { headerLinks, useOnlineStatus, usePartners } from '@shared';
import { RouteEnum, useSession } from 'App';

export function useHeaderHook() {
  const [isOpen, setIsOpen] = useState(false);
  const {
    currentUser: { roles, partnerUUIDs },
    initialPage,
  } = useSession();
  const isOnline = useOnlineStatus();

  const { isAuditor, isInstructor, isLeadAuditor } = roles;
  const isShowSearchBar = isInstructor || isLeadAuditor;

  const isMultiplePartners =
    !isAuditor && !isLeadAuditor && isInstructor && partnerUUIDs.length > 1;

  const { data } = usePartners(isMultiplePartners);

  const filteredHeaderLinks = headerLinks.filter(({ path }) => {
    switch (path) {
      case RouteEnum.Partners:
        return isLeadAuditor || (isInstructor && isAuditor);
      case RouteEnum.AuditQueue:
        return isLeadAuditor || isAuditor;
      case RouteEnum.NeedsReview:
      case RouteEnum.IncompleteAudits:
        return isLeadAuditor;
      default:
        return false;
    }
  });
  return {
    isOpen,
    setIsOpen,
    filteredHeaderLinks,
    initialPage,
    isOnline,
    isShowSearchBar,
    isMultiplePartners,
    partners: data?.map((i) => ({ label: i.name, id: i.uuid })),
  };
}
